<template>
  <div class="profile-data-form-group">
    <v-layout
      class="row--data mt-0"
      row
    >
      <v-flex xs5>
        <v-subheader class="v-subheader--dense font-weight-medium">Name</v-subheader>
      </v-flex>
      <v-flex xs7>
        <div
          :id="`${transactionPartyType}-name`"
          class="font-weight-medium"
        >{{ profile.name }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs5>
        <v-subheader class="v-subheader--dense">
          <template v-if="profile.isLegal">Register number</template>
          <template v-else>Personal code</template>
        </v-subheader>
      </v-flex>
      <v-flex xs7>
        <div :id="`${transactionPartyType}-code`">{{ profile.regNumber }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs5>
        <v-subheader class="v-subheader--dense">Address</v-subheader>
      </v-flex>
      <v-flex xs7>
        <div :id="`${transactionPartyType}-address`">{{ profile.address }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs5>
        <v-subheader class="v-subheader--dense">Country</v-subheader>
      </v-flex>
      <v-flex xs7>
        <div :id="`${transactionPartyType}-country`">{{ getCountryName(profile.country) }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data mb-0"
      row
    >
      <v-flex xs5>
        <v-subheader class="v-subheader--dense mt-1">Account Nr.</v-subheader>
      </v-flex>
      <v-flex xs7>
        <account-select
          :id="`${transactionPartyType}-iban`"
          :value="account"
          :accounts="accountOptions"
          :disabled="disabled"
          single-line
          auto-reset
          @change="onAccountSelect"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  // Models
  import Profile from '@/models/AccountProfile'

  // Mixins
  import countries from '@/mixins/countries'

  // Components
  import AccountSelect from '@/components/ui/AccountSelect'

  export default {
    name: 'ProfileDataFormGroup',
    components: {
      AccountSelect
    },
    mixins: [countries],
    props: {
      profile: {
        required: true,
        type: Profile
      },
      account: {
        required: true,
        type: String
      },
      accountOptions: {
        required: true,
        type: Array
      },
      transactionPartyType: {
        required: true,
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onAccountSelect (account) {
        this.$emit('update:account', account)
        this.$emit('selectAccount', account)
      }
    }
  }
</script>
